import { useParams, useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/lib/constants";
import { useServiceQuery } from "@/hooks/use-services";
import { useAuthStore } from "@/stores/auth-store";
import { useServiceStore } from "@/stores/service-store";

export function OnboardingDonePage() {
  const { serviceId } = useParams<{ serviceId?: string }>();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const { setSelectedService } = useServiceStore();

  const { data: service, isLoading: isServiceLoading } = useServiceQuery(
    isAuthenticated ? serviceId || "" : ""
  );

  const handleContinue = () => {
    if (serviceId && service) {
      setSelectedService(service);
    }
    navigate("/onboarding/notification");
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <img
        src={LOGO_URL}
        alt=""
        className="mb-6 h-12 w-auto"
      />
      <h1 className="text-2xl font-semibold tracking-[-0.01em]">
        Mobile setup completed
      </h1>
      <div className="mt-6">
        {isAuthenticated ? (
          <Button
            onClick={handleContinue}
            disabled={serviceId ? isServiceLoading : false}
          >
            Continue
          </Button>
        ) : (
          <p className="text-sm text-muted-foreground">You can close this page now.</p>
        )}
      </div>
    </div>
  );
}
